var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 33.9",
    style: {
      enableBackground: "new 0 0 40 33.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E0E0E0;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:none;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,5.1C25.4-1.3,15-1.3,8.5,5.1C3.3,10.4,2.2,18.5,5.9,25l-2.3,8.5l8.7-2.3c2.4,1.3,5.1,2,7.9,2l0,0 c9.1,0,16.4-7.4,16.4-16.4C36.6,12.4,34.9,8.2,31.8,5.1z M20.2,30.4L20.2,30.4c-2.5,0-4.9-0.7-7-1.9l-0.5-0.3l-5.2,1.4l1.4-5L8.6,24 c-4-6.4-2.1-14.8,4.3-18.8s14.8-2.1,18.8,4.3s2.1,14.8-4.3,18.8C25.3,29.7,22.7,30.4,20.2,30.4L20.2,30.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -547.9818,
    y1: 2.1546,
    x2: -547.9818,
    y2: 1.8227,
    gradientTransform: "matrix(95.0094 0 0 95.4419 52083.4922 -173.0802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20B038"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#60D66A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,32.6l2.2-8.1C2.2,16.9,4.8,7.3,12.3,3s17.1-1.7,21.4,5.8s1.7,17.1-5.8,21.4c-2.4,1.4-5.1,2.1-7.8,2.1l0,0 c-2.6,0-5.2-0.7-7.5-1.9L4.3,32.6L4.3,32.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,8.2h18.5v17.3H10.9V8.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.1,9.8c-0.3-0.7-0.6-0.7-0.9-0.7c-0.2,0-0.5,0-0.8,0c-0.4,0-0.8,0.2-1.1,0.5c-0.9,0.9-1.4,2.1-1.4,3.4 c0,2,1.5,3.9,1.7,4.2c0.2,0.3,2.8,4.5,6.9,6.1c3.4,1.4,4.1,1.1,4.9,1c0.7-0.1,2.4-1,2.7-1.9c0.3-0.9,0.3-1.8,0.2-1.9 s-0.4-0.3-0.8-0.5s-2.4-1.2-2.8-1.3c-0.4-0.1-0.6-0.2-0.9,0.2c-0.3,0.4-1,1.3-1.3,1.6s-0.5,0.3-0.9,0.1c-1.2-0.5-2.3-1.2-3.3-2 c-0.9-0.8-1.6-1.8-2.3-2.8c-0.2-0.4,0-0.6,0.2-0.8c0.2-0.2,0.4-0.5,0.6-0.7s0.3-0.4,0.4-0.7c0.1-0.2,0.1-0.5,0-0.7 C17.3,12.6,16.5,10.6,16.1,9.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.7,5.1c-6.3-6.4-16.6-6.4-23,0c-5.2,5.2-6.3,13.2-2.6,19.6l-2.3,8.4l8.6-2.3c2.4,1.3,5.1,2,7.8,2l0,0 c9,0,16.3-7.3,16.3-16.3C36.4,12.3,34.7,8.1,31.7,5.1z M20.2,30.1L20.2,30.1c-2.4,0-4.8-0.7-6.9-1.9l-0.5-0.3l-5.1,1.3l1.4-5 l-0.3-0.5C4.8,17.4,6.7,9,13.1,5.1S27.8,3,31.7,9.4s2.1,14.7-4.3,18.6C25.2,29.4,22.7,30.1,20.2,30.1L20.2,30.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.5f46823dcda3639245bc778e54154b5e.svg";
export { ForwardRef as ReactComponent };